import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LandingBackground from '../components/landing/LandingBackground';
import LandingHeader from '../components/landing/LandingHeader';
import HeroSection from '../components/landing/HeroSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import FeatureDeepDivesSection from '../components/landing/FeatureDeepDivesSection';
import AgentsSection from '../components/landing/AgentsSection';
import CustomLogicSection from '../components/landing/CustomLogicSection';
import LandingFooter from '../components/landing/LandingFooter';

const LandingPage = () => {
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => setScrollY(container.scrollTop);
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLoginClick = () => {
    setIsTransitioning(true);
    setTimeout(() => navigate('/login'), 600);
  };

  const scrollToSection = () => {
    const el = document.getElementById('how-it-works');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Box
      ref={containerRef}
      data-joy-color-scheme="light"
      sx={{
        height: '100%',
        background: 'linear-gradient(135deg, #e8f4fd 0%, #d1e9f9 50%, #bbddf5 100%)',
        position: 'relative',
        overflowX: 'hidden',
        overflowY: 'auto',
        opacity: isTransitioning ? 0 : 1,
        transform: isTransitioning ? 'translateY(-50px) scale(0.95)' : 'translateY(0) scale(1)',
        transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        filter: isTransitioning ? 'blur(2px)' : 'blur(0px)'
      }}
    >
      <LandingBackground scrollY={scrollY} isTransitioning={isTransitioning} />
      <LandingHeader handleLoginClick={handleLoginClick} isTransitioning={isTransitioning} scrollY={scrollY} />
      <HeroSection scrollToSection={scrollToSection} navigate={navigate} isTransitioning={isTransitioning} />
      <HowItWorksSection />
      <FeatureDeepDivesSection />
      <AgentsSection />
      <CustomLogicSection navigate={navigate} />
      <LandingFooter />
    </Box>
  );
};

export default LandingPage;
